<div class="admin-shell">
  <header class="admin-header">
    <img src="../../../assets/OTD-logo-white.png" width="90px" class="logo" alt="OnTap Data" />
    <h1>Administration</h1>
    <nav class="admin-nav">
      <a routerLink="/admin/users" routerLinkActive="active">Users</a>
      <a routerLink="/admin/groups" routerLinkActive="active">Groups</a>
      <a routerLink="/admin/locations" routerLinkActive="active">Locations</a>
    </nav>
    <dx-button class="logout-btn" text="Log out" icon="runner" stylingMode="text"
      (onClick)="logout()"></dx-button>
  </header>
  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>
</div>
